import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import SearchBar from "components/search-bar.component";

import { getLatestJobs, getLatestVacancies, safeApiCall } from "services/employer.service";
import { Job, Vacancy } from "services/types";
import JobCard from "components/job-card.component";
import VacancyCard from "components/vacancy-card.component";

function HomePage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true);
  const [latestJobs, setLatestJobs] = useState<Job[]>([]);
  const [latestVacancies, setLatestVacancies] = useState<Vacancy[]>([]);

  useEffect(() => {
    (async () => {
      await safeApiCall(
        () => getLatestJobs(),
        (res: any) => setLatestJobs(res.data.jobs)
      );
    })()
  }, []);

  useEffect(() => {
    (async () => {
      await safeApiCall(
        async () => {
          const limit = Math.max(0, 9 - latestJobs.length);

          if (limit > 0) {
            return getLatestVacancies(limit);
          } else {
            return Promise.resolve({ data: { vacancies: [] } });
          }
        },
        (res: any) => {
          setLatestVacancies(res.data.vacancies);
        }
      );
      setLoading(false)
    })()
  }, [latestJobs]);

  return (
    <>
      {loading ? (
        <div id="preloader" />
      ) : (
        <>
          <section className="about section" style={{ paddingTop: '60px' }}>
            <div className="container" data-aos="fade-up" data-aos-delay="100">
              <div className="section-header text-center" style={{ marginBottom: "2rem" }}>
                <SearchBar
                  onSearch={() => {
                    navigate("/latest-jobs")
                  }}
                />
              </div>

              <div className="section-header text-center">
                <h2
                  className="section-title"
                  style={{ paddingBottom: "30px" }}
                >
                  Manage your hiring from start to finish
                </h2>
              </div>

              <div className="row g-4 align-items-stretch justify-content-center">
                <div className="col-md-4 col-lg-4" data-aos="fade-up" data-aos-delay="500">
                  <a
                    href={`${process.env.REACT_APP_FRONTEND_PORTAL_URL}/#/verify-email?action=upload-cv`}
                    className="text-decoration-none text-reset"
                  >
                    <div className="icon-box equal-height">
                      <i className="bi bi-upload"></i>
                      <h3>CV Upload</h3>
                      <p>Your next voyage starts here...</p>
                    </div>
                  </a>
                </div>

                <div className="col-md-4 col-lg-4" data-aos="fade-up" data-aos-delay="200">
                  <a
                    href={`${process.env.REACT_APP_FRONTEND_PORTAL_URL}/#/verify-email?action=post-a-job`}
                    className="text-decoration-none text-reset"
                  >
                    <div className="icon-box equal-height">
                      <i className="bi bi-briefcase-fill"></i>
                      <h3>Post a job</h3>
                      <p>Find certified seafarers.​</p>
                    </div>
                  </a>
                </div>

                <div className="col-md-4 col-lg-4" data-aos="fade-up" data-aos-delay="300">
                  <a href="/latest-jobs" className="text-decoration-none text-reset">
                    <div className="icon-box equal-height">
                      <i className="bi bi-search"></i>
                      <h3>Find a job</h3>
                      <p>Set sail with confidence. Your next job is here...</p>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </section>

          <section className="jobs section">
            <div className="container" data-aos="fade-up">
              <div className="section-header text-center mb-4">
                <h2>Latest Job Openings</h2>
                <p>Explore opportunities that match your skills and experience</p>
              </div>

              <div className="row g-4 justify-content-center">
                {latestJobs.map((job) => (
                  <JobCard key={job.ref_id} job={job} />
                ))}
                {latestVacancies.map((vacancy) => (
                  <VacancyCard key={vacancy.ref_id} vacancy={vacancy} />
                ))}
              </div>
              {latestJobs.length + latestVacancies.length}
              {(latestJobs.length + latestVacancies.length) === 9 && (
                <div className="row g-4 justify-content-center mt-2">
                  <div className="col-auto">
                    <Link className="btn btn-indigo" to="/latest-jobs">
                      <i className="bi bi-arrow-down-circle me-2"></i>
                      Load More
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </section>
        </>
      )}
    </>
  );
}

export default HomePage;
